<script>
// エステ魂と同じコンポーネントにする必要があるため
import ThirtyComponent from "./30.vue";
export default ThirtyComponent;
</script>
